import Stepper from 'bs-stepper';
import answersTodtenweis from "./quizAnswersTodtenweis";

// Make jQuery globally available
// Should work in webpack as well.
window.$ = window.jQuery = jQuery;

/**
 * Stepper Logic
 */
var stepper1

stepper1 = new Stepper(document.querySelector('#stepper1'))

let stepNextList = [].slice.call(document.querySelectorAll('[data-step=next]'));
let stepPrevList = [].slice.call(document.querySelectorAll('[data-step=previous]'));

stepNextList.forEach(function (btn) {
  btn.addEventListener('click', function () {
    stepper1.next()
  })
})
stepPrevList.forEach(function (btn) {
  btn.addEventListener('click', function () {
    stepper1.previous()
  })
})

let quiz_radios = document.querySelectorAll('[name="quizRadios"]');


/**
 * Modal Logic
 */

$('#myModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget) // Button that triggered the modal
  console.log($(event.relatedTarget))
  console.log(event.relatedTarget.value)
  let val_string = event.relatedTarget.value;
  let answer = val_string.split(':');
  console.log(answer)
  var modal = $(this)
  modal.addClass(answer[2]);
  modal.find('.modal-body').html(function () {
    return answersTodtenweis[answer[0]][answer[1]]
  });
})
$('#myModal').on('hide.bs.modal', function (event) {
  var modal = $(this)
  modal.hasClass("answer--true") ? modal.removeClass("answer--true") : '';
  modal.hasClass("answer--false") ? modal.removeClass("answer--false") : '';
});